import { createSelector } from 'reselect'

export const getEquipmentVisibility = createSelector(
  (state) => state && state.ads && state.ads.equipment && state.ads.equipment.visibility
    ? state.ads.equipment.visibility : {},
  (equipmentVisibility) => equipmentVisibility
)
